// src/components/Footer.jsx
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FaLinkedinIn } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa6";
import { FaFacebookF } from "react-icons/fa";
const Footer = () => {
  const [services, setServices] = useState([]);

  const [loading, setLoading] = useState(true);
  // Fetch services on component mount
  useEffect(() => {
    fetchServices();
  }, []);

  const fetchServices = async () => {
    try {
      const apiUrl = localStorage.getItem("api_url");
      const companyId = "1"; // Replace with your actual company_id
      const employeeId = "1"; // Replace with your actual employee_id

      const formData = new FormData();
      formData.append("company_id", companyId);
      formData.append("employee_id", employeeId);
      formData.append("type", "1"); // Type 1 to fetch all services

      const response = await fetch(`${apiUrl}service.php`, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (data.status === "1") {
        setServices(data.result);
        console.log("Services loaded successfully:", data.result);
      } else {
        console.error("Failed to fetch services:", data.error);
        setServices([]);
      }
    } catch (error) {
      console.error("Error fetching services:", error);
      setServices([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer className="footer">
      <div className="footer-primary">
        <div className="container">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-4">
              <div className="footer-widget-about">
                <h6 className="footer-widget-title">
                  Sign up for alerts, monthly insights, strategic business
                  perspectives and exclusive content in your inbox.
                </h6>
                <Link
                  to="/contact-us"
                  className="btn btn-white arrow-hover-flip-up"
                >
                  <span>Reach Us</span>
                  <svg
                    className="arrow-flip"
                    viewBox="0 0 64 64"
                    width="12"
                    height="12"
                  >
                    <g className="arrow-flip-path-1">
                      <path
                        d="m56 6h-48c-1.104 0-2 .896-2 2s.896 2 2 2h43.171l-44.585 44.586c-.781.781-.781 2.047 0 2.828.391.391.902.586 1.414.586s1.024-.195 1.414-.586l44.586-44.586v43.172c0 1.104.896 2 2 2s2-.896 2-2v-48c0-1.104-.896-2-2-2z"
                        fill="currentColor"
                      ></path>
                    </g>
                    <g className="arrow-flip-path-2">
                      <path
                        d="m56 6h-48c-1.104 0-2 .896-2 2s.896 2 2 2h43.171l-44.585 44.586c-.781.781-.781 2.047 0 2.828.391.391.902.586 1.414.586s1.024-.195 1.414-.586l44.586-44.586v43.172c0 1.104.896 2 2 2s2-.896 2-2v-48c0-1.104-.896-2-2-2z"
                        fill="currentColor"
                      ></path>
                    </g>
                  </svg>
                </Link>
              </div>
            </div>

            <div className="col-6 col-sm-6 col-md-4 col-lg-2">
              <div className="footer-widget-nav">
                <h6 className="footer-widget-title">Company</h6>
                <nav>
                  <ul className="footer-nav-list list-unstyled">
                    <li>
                      <Link to="/about-us">About Us</Link>
                    </li>
                    <li>
                      <Link to="/blogs">Blogs</Link>
                    </li>
                    <li>
                      <Link to="/faq">FAQ</Link>
                    </li>
                    <li>
                      <Link to="/pricing">Pricing</Link>
                    </li>
                    <li>
                      <Link to="/careers">Careers</Link>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>

            <div className="col-6 col-sm-6 col-md-4 col-lg-2">
              <div className="footer-widget-nav">
                <h6 className="footer-widget-title">Services</h6>
                <nav>
                  <ul className="footer-nav-list list-unstyled">
                    {services.map((service) => (
                      <li className="nav-item" key={service.service_id}>
                        <Link
                          to={`/serviceDetails/${service.service_id}`}
                          className="nav-item-link"
                        >
                          {service.service_title}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </nav>
              </div>
            </div>

            <div className="col-6 col-sm-6 col-md-4 col-lg-2">
              <div className="footer-widget-nav">
                <h6 className="footer-widget-title">Quick Contacts</h6>
                <ul className="footer-nav-list contact-list list-unstyled">
                  <li>
                    <a
                      href={`mailto:${localStorage.getItem("company_email") || "sales@sunshineinfotech.in"}`}
                    >
                      {localStorage.getItem("company_email") ||
                        "sales@sunshineinfotech.in"}
                    </a>
                  </li>
                  <li>
                    <a
                      href={`tel:${localStorage.getItem("company_mobile_1") || "+919316392980"}`}
                    >
                      {localStorage.getItem("company_mobile_1") ||
                        "+91 93163 92980"}
                    </a>
                  </li>
                </ul>
                <ul className="social-icons social-icons-light list-unstyled mb-0">
                  <li>
                    <Link
                      target="_blank"
                      to={localStorage.getItem("company_fb_link") || "#"}
                    >
                      <FaFacebookF size={16} />
                    </Link>
                  </li>
                  <li>
                    <Link
                      target="_blank"
                      to={localStorage.getItem("company_linkedIn_link") || "#"}
                    >
                      <FaLinkedinIn size={16} />
                    </Link>
                  </li>
                  <li>
                    <Link
                      target="_blank"
                      to={localStorage.getItem("company_insta_link") || "#"}
                    >
                      <FaInstagram size={16} />
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-secondary">
        <div className="container">
          <div className="row align-items-center">
            <div class="col-12">
              <Link
                to={"/contact-us"}
                class="contatct-text d-flex justify-content-between arrow-hover-flip-up"
              >
                <span class="contact-text-title">Get In Touch</span>
                <svg
                  class="arrow-flip"
                  enable-background="new 0 0 64 64"
                  viewBox="0 0 64 64"
                  width="100"
                  height="100"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g class="arrow-flip-path-1">
                    <path
                      d="m56 6h-48c-1.104 0-2 .896-2 2s.896 2 2 2h43.171l-44.585 44.586c-.781.781-.781 2.047 0 2.828.391.391.902.586 1.414.586s1.024-.195 1.414-.586l44.586-44.586v43.172c0 1.104.896 2 2 2s2-.896 2-2v-48c0-1.104-.896-2-2-2z"
                      fill="currentColor"
                    ></path>
                  </g>
                  <g class="arrow-flip-path-2">
                    <path
                      d="m56 6h-48c-1.104 0-2 .896-2 2s.896 2 2 2h43.171l-44.585 44.586c-.781.781-.781 2.047 0 2.828.391.391.902.586 1.414.586s1.024-.195 1.414-.586l44.586-44.586v43.172c0 1.104.896 2 2 2s2-.896 2-2v-48c0-1.104-.896-2-2-2z"
                      fill="currentColor"
                    ></path>
                  </g>
                </svg>
              </Link>
            </div>

            <div className="col-12 d-flex flex-wrap justify-content-between align-items-center">
              <div className="footer-copyrights my-2">
                <span className="fz-14">
                  &copy; 2025 allianz, All Rights Reserved. With Love by{" "}
                </span>
                <a
                  className="fz-14 color-white"
                  href="https://sunshineinfotech.in/"
                >
                  Sunshine Infotech
                </a>
              </div>
              <nav>
                <ul className="footer-copyright-links d-flex align-items-center list-unstyled flex-wrap my-2">
                  <li>
                    <Link to="/terms">Terms & Conditions</Link>
                  </li>
                  <li>
                    <Link to="/privacy">Privacy Policy</Link>
                  </li>
                  <li>
                    <Link to="/sitemap">Site Map</Link>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
